<h1 [ngStyle]="data.titleStyle" mat-dialog-title>{{data.title ?? 'Do you really want to cancel?'}}</h1>
<div mat-dialog-content>
  <span [ngStyle]="data.contentStyle" [innerHTML]="data.content ?? 'All unsaved data will be lost.'"></span>
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="warn" (click)="data.onConfirm()">{{data?.confirmButtonText ?? 'Yes'}}</button>
  <button *ngIf="data?.onDecline" mat-button mat-dialog-close color="accent" cdkFocusInitial (click)="data.onDecline()">No</button>
</div> 